module.exports = __webpack_public_path__ + "img/app-development.f9848216.png";